import styled from 'styled-components';
export const DesktopLinkWrapper = styled.div `
  display: flex;
  align-items: center;
  column-gap: 16px;
  width: 100%;

  @media all and (min-width: 840px) {
    display: none;
  }
`;
export const InfoWrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
export const Name = styled.span `
  font-size: var(--font-size-xxs);
  color: var(--color-neutral-130);
`;
export const Myaccount = styled.span `
  font-size: var(--font-size-xxs);
  color: var(--color-secondary-100);
  margin-top: 3px;
`;
export const ChevronRightWrapper = styled.div `
  margin-left: auto;
`;
export const TabletLinkWrapper = styled.div `
  display: flex;
  align-items: center;
  column-gap: 16px;

  @media all and (max-width: 839px) {
    display: none;
  }
`;
